const TeachersHeader = props => {
    return (
        <header id="teacher-header">
            {props.content}
        </header>
    )
}

export default TeachersHeader;